import { createApp } from "vue";
import i18n from "../translations/i18n";
import aa from "search-insights";
import { algoliaAppId, algoliaKeySearch } from "../algoliaSettings";
import AlgoliaSearchInput from "../../components/Algolia/AlgoliaSearchInput.vue";
import AutoComplete from "../../components/Algolia/Autocomplete/AutoComplete.vue";
import SearchResultWrapper from "../../components/Algolia/SearchResultWrapper.vue";
import AlgoliaSearchInputApp from "../../components/Algolia/AlgoliaSearchInputApp.vue";
import AlgoliaSearchInputMobile from "../../components/Algolia/AlgoliaSearchInputMobile.vue";
import SearchResultWrapperCategory from "../../components/Algolia/SearchResultWrapperCategory.vue";
import AlgoliaRecommendations from "../../components/Algolia/AlgoliaRecommendations.vue";

export const initializeAlgoliaAnalytics = () => {
    if (algoliaAppId() && algoliaKeySearch()) {
        aa("init", {
            appId: algoliaAppId(),
            apiKey: algoliaKeySearch(),
            useCookie: true,
        });

        window.aa = aa;
    }

    window.getAlgoliaUserToken = () => {
        return new Promise((resolve) => {
            aa('getUserToken', null, (err, newUserToken) => {
                if (err) {
                    console.error(err);

                    resolve(null);
                }

                resolve(newUserToken);
            });
        });
    };

    window.sendAlgoliaEvent = async (event) => {
        event.userToken = await window.getAlgoliaUserToken();

        aa('sendEvents', [event]);
    };
};

export const initializeAlgoliaSearchApp = () => {
    if (!document.getElementById('js_algoliaSearch')) {
        return;
    }

    createApp({
        components: {
            AlgoliaSearchInput,
            AutoComplete,
            SearchResultWrapper,
        }
    })
        .use(i18n)
        .mount('#js_algoliaSearch');
};

export const initializeAlgoliaSearchMobileApp = () => {
    if (!document.getElementById('js_algoliaSearchMobile')) {
        return;
    }

    createApp({
        components: {
            AlgoliaSearchInputMobile,
            AlgoliaSearchInputApp,
        }
    })
        .use(i18n)
        .mount('#js_algoliaSearchMobile');
};

export const initializeAlgoliaSearchCategoryApp = () => {
    if (!document.getElementById('js_algoliaSearchCategory')) {
        return;
    }

    createApp({
        components: { SearchResultWrapperCategory }
    })
        .use(i18n)
        .mount('#js_algoliaSearchCategory');

};

export const initializeAlgoliaRecommendationsApp = () => {
    if (!document.getElementById('js_AlgoliaRecommendations')) {
        return;
    }

    createApp({
        components: { AlgoliaRecommendations }
    })
        .use(i18n)
        .mount('#js_AlgoliaRecommendations');

};

